import React, { useCallback, useState } from 'react';

import ANALYTICS_CATEGORIES from '../../../../analytics/categories';
import { useMutateOutbox } from '../../../../fetchHooks/useOutbox';
import { AnalyticsEvents, trackEvent } from '../../../../services/analytics';
import createOutboxRequest from '../form/createOutboxRequest';
import { PaymentState } from '../form/state';

const usePaymentOutbox = (
    state: PaymentState,
    checkFormValidity: (event: React.FormEvent<unknown> | React.MouseEvent<unknown>) => Promise<boolean>,
    onClearPayment: () => void,
) => {
    const [isPostingOutboxItem, setIsPostingOutboxItem] = useState(false);
    const outboxMutation = useMutateOutbox();

    const onCreateOutboxPayment = useCallback(
        async (event: React.MouseEvent<HTMLButtonElement>) => {
            if (await checkFormValidity(event)) {
                trackEvent(AnalyticsEvents.PAYMENT, ANALYTICS_CATEGORIES.PAYMENT, 'create_bulk_payment');
                setIsPostingOutboxItem(true);

                outboxMutation
                    .mutateAsync(createOutboxRequest(state))
                    .then(() => {
                        setIsPostingOutboxItem(false);
                        onClearPayment();
                    })
                    .catch(() => setIsPostingOutboxItem(false));
            } else {
                trackEvent(AnalyticsEvents.PAYMENT, ANALYTICS_CATEGORIES.PAYMENT, 'validation_error');
            }
        },
        [state, checkFormValidity, onClearPayment, outboxMutation],
    );

    return { isPostingOutboxItem, onCreateOutboxPayment, error: outboxMutation.error };
};

export default usePaymentOutbox;
